import { createLogger } from '@/core/helpers/logger.helper';
import type { NotificationApi, NotificationApiOptions } from '@/core/network/api/notification/notification.api';
import type { GamResponse } from '@/core/network/http/httpClient.interface';
import { HttpError } from '@/core/network/http/httpError';
import type { NotificationDto } from './notification.interface';

const logger = createLogger('NotificationRepository');

export class NotificationRepository {
  private readonly httpAPI: NotificationApi;

  constructor(httpAPI: NotificationApi) {
    this.httpAPI = httpAPI;
  }

  async getNotifications(options?: NotificationApiOptions): Promise<GamResponse<NotificationDto[]> | null> {
    try {
      const response = await this.httpAPI.getNotifications(options);
      if (response.data?.data) {
        return {
          data: response.data.data,
          cursor: response.data.cursor,
          // @ts-ignore
          unreadCount: response.data.unreadCount,
        };
      } else {
        return null;
      }
    } catch (e) {
      const httpError = e as HttpError;
      logger.error(`${httpError.error.code} => ${httpError.error.message}`);
      throw httpError.error;
    }
  }

  async markAsRead(id: string): Promise<GamResponse<{ unreadCount: number }> | null> {
    try {
      const response = await this.httpAPI.markAsRead(id);
      if (response.data?.data) {
        return {
          data: response.data.data,
        };
      } else {
        return null;
      }
    } catch (e) {
      const httpError = e as HttpError;
      logger.error(`${httpError.error.code} => ${httpError.error.message}`);
      throw httpError.error;
    }
  }

  async markAllAsRead(): Promise<GamResponse<{ unreadCount: number }> | null> {
    try {
      const response = await this.httpAPI.markAllAsRead();
      if (response.data?.data) {
        return {
          data: response.data.data,
        };
      } else {
        return null;
      }
    } catch (e) {
      const httpError = e as HttpError;
      logger.error(`${httpError.error.code} => ${httpError.error.message}`);
      throw httpError.error;
    }
  }

  async deleteAll(): Promise<GamResponse<{ deletedCount: number }> | null> {
    try {
      const response = await this.httpAPI.deleteAll();
      if (response.data?.data) {
        return {
          data: response.data.data,
        };
      } else {
        return null;
      }
    } catch (e) {
      const httpError = e as HttpError;
      logger.error(`${httpError.error.code} => ${httpError.error.message}`);
      throw httpError.error;
    }
  }
}
